import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Link, useLocation, useNavigate} from "react-router-dom";
import { LOGIN_ROUTE, REGISTRATION_ROUTE } from "../utils/consts";
import { login, registration } from "../http/userAPI";
import { useState } from "react";
import { Context } from "../index";
import {observer} from "mobx-react-lite";


const Auth = observer(() => {
  const location = useLocation();
  const isLogin = location.pathname === LOGIN_ROUTE;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const {user} = useContext(Context) 

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      let data
      if (isLogin) {
        data = await login(phoneNumber, password);
        console.log('Успешный вход:', data);
        navigate('/'); // Перенаправляем на главную страницу после логина
      } else {
        data = await registration(phoneNumber, password);
        navigate(LOGIN_ROUTE); // Перенаправляем на страницу логина после регистрации
      }
      user.setUser(user)
      user.setIsAuth(true)
    } catch (e) {
      alert(e.response.data.message)
    }
  };

  return (
    <Container 
      className="d-flex justify-content-center align-items-center"
      style={{ height: window.innerHeight / 2 }}
    >
      <Card style={{ width: 600 }} className="p-5">
        <h2 className="m-auto">{isLogin ? 'Авторизация' : 'Регистрация'}</h2>
        <Form className="d-flex flex-column">
          <Form.Control
            className="mt-3"
            placeholder="Введите ваш номер телефона..."
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <Form.Control
            className="mt-3"
            placeholder="Введите ваш пароль..."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
          />
          <div className="d-flex justify-content-between align-items-center mt-3">
            {isLogin ? (
              <div>
                Нет аккаунта? <Link to={REGISTRATION_ROUTE}>Зарегистрируйтесь!</Link>
              </div>
            ) : (
              <div>
                Есть аккаунт? <Link to={LOGIN_ROUTE}>Войдите!</Link>
              </div>
            )}
            <Button onClick={handleClick} variant="outline-dark">
              {isLogin ? 'Войти' : 'Регистрация'}
            </Button>
          </div>
        </Form>
      </Card>
    </Container>
  );
});

export default Auth;